module.exports = __webpack_public_path__ + "static/step-hand-mob-77c893e73f6fcbf758b9f2a4d2c8eedf.svg";